var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-subtitle mt-5 mb-4"},[_vm._v("Account Options")]),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"md":"6","sm":"6"}},[_c('b-button',{staticClass:"delete-btn",attrs:{"block":"","variant":"error"},on:{"click":function($event){return _vm.$router.push({
            name: 'user.verify-page',
            params: { field: 'account' },
          })}}},[_vm._v("Delete")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }